import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traduzioni
const resources = {
  en: {
    translation: {
      // Logo
      "logo.claim": "AI Finds Your Best Travel Deals",
      
      // Navigation
      "nav.title": "traveldiscount.ai",
      "nav.subtitle": "Smart Last-Minute Deals",
      "nav.switchRole": "Switch Role",
      "nav.dashboard": "Dashboard",
      "nav.logout": "Logout",
      "nav.registerProperty": "Register Property",
      
      // Chat
      "chat.assistant": "Assistant",
      "chat.welcomeMessage": "Welcome to traveldiscount.ai. Are you looking for last-minute deals or managing property requests?",
      "chat.travelerContext": "Finding you the perfect last-minute deal",
      "chat.propertyContext": "Managing traveler requests",
      "chat.defaultContext": "Let's get started",
      "chat.travelerResponse": "Great! Search for deals below or tell me what you're looking for.",
      "chat.propertyResponse": "Perfect! Browse traveler requests below or search by city and dates.",
      "chat.placeholderTraveler": "Try: Rome, 2 people, 80 euros",
      "chat.placeholderProperty": "Try: Milan or budget 100 euros",
      "chat.send": "Send",
      "chat.foundDeals": "Found {count} matching deals. Check the list below.",
      "chat.noDeals": "No exact matches found. Try different criteria or check all available deals below.",
      "chat.foundRequests": "Found {count} matching requests. See details below.",
      "chat.noRequests": "No matching requests. Try different search terms.",
      
      // User Type Selection
      "userType.traveler": "I'm a Traveler",
      "userType.travelerDesc": "Find last-minute deals",
      "userType.property": "I'm a Property Owner",
      "userType.propertyDesc": "Accept traveler requests",
      
      // Filters
      "filters.title": "Quick Filters",
      "filters.city": "City",
      "filters.searchCity": "Search city...",
      "filters.noCityFound": "No city found.",
      "filters.maxBudget": "Max Budget",
      "filters.search": "Search",
      
      // Deals
      "deals.title": "Last-Minute Deals",
      "deals.noDeals": "No deals available",
      "deals.available": "{count} available",
      "deals.bookNow": "Book Now",
      "deals.perNight": "per night",
      "deals.nights": "{count} nights",
      
      // Requests
      "requests.title": "Traveler Requests",
      "requests.noRequests": "No requests available",
      "requests.guests": "{count} guests",
      "requests.notes": "Notes",
      "requests.acceptRequest": "Accept Request",
      "requests.registerToAccept": "Register to Accept",
      "requests.registerFirst": "Register your property first",
      "requests.viewChat": "View Chat",
      
      // Status
      "status.available": "Available",
      "status.open": "Open",
      "status.inProgress": "In Progress",
      "status.completed": "Completed",
      "status.soldOut": "Sold Out",
      
      // Labels
      "label.tonight": "Tonight",
      "label.lastMinute": "Last Minute",
      "label.weekend": "Weekend",
      
      // Calendar
      "calendar.title": "Select Dates (Next 14 Days)",
      "calendar.clear": "Clear",
      "calendar.desktopInstructions": "Desktop: Click & drag to select range",
      "calendar.mobileInstructions": "Mobile: Tap for single, hold & drag for range",
      "calendar.selected": "Selected",
      "calendar.day": "day",
      "calendar.days": "days",
      
      // Messages
      "message.loggedOut": "Logged out"
    }
  },
  it: {
    translation: {
      // Logo
      "logo.claim": "L'AI Trova le Tue Migliori Offerte di Viaggio",
      
      // Navigation
      "nav.title": "traveldiscount.ai",
      "nav.subtitle": "Offerte Last-Minute Intelligenti",
      "nav.switchRole": "Cambia Ruolo",
      "nav.dashboard": "Dashboard",
      "nav.logout": "Esci",
      "nav.registerProperty": "Registra Proprietà",
      
      // Chat
      "chat.assistant": "Assistente",
      "chat.welcomeMessage": "Benvenuto su traveldiscount.ai. Stai cercando offerte last-minute o gestisci richieste di proprietà?",
      "chat.travelerContext": "Ti trovo l'offerta last-minute perfetta",
      "chat.propertyContext": "Gestisco le richieste dei viaggiatori",
      "chat.defaultContext": "Iniziamo",
      "chat.travelerResponse": "Ottimo! Cerca offerte qui sotto o dimmi cosa stai cercando.",
      "chat.propertyResponse": "Perfetto! Esplora le richieste dei viaggiatori qui sotto o cerca per città e date.",
      "chat.placeholderTraveler": "Es: Roma, 2 persone, 80 euro",
      "chat.placeholderProperty": "Es: Milano o budget 100 euro",
      "chat.send": "Invia",
      "chat.foundDeals": "Trovate {count} offerte corrispondenti. Controlla l'elenco qui sotto.",
      "chat.noDeals": "Nessuna corrispondenza esatta. Prova criteri diversi o controlla tutte le offerte disponibili qui sotto.",
      "chat.foundRequests": "Trovate {count} richieste corrispondenti. Vedi i dettagli qui sotto.",
      "chat.noRequests": "Nessuna richiesta corrispondente. Prova termini di ricerca diversi.",
      
      // User Type Selection
      "userType.traveler": "Sono un Viaggiatore",
      "userType.travelerDesc": "Trova offerte last-minute",
      "userType.property": "Sono un Proprietario",
      "userType.propertyDesc": "Accetta richieste viaggiatori",
      
      // Filters
      "filters.title": "Filtri Rapidi",
      "filters.city": "Città",
      "filters.searchCity": "Cerca città...",
      "filters.noCityFound": "Nessuna città trovata.",
      "filters.maxBudget": "Budget Massimo",
      "filters.search": "Cerca",
      
      // Deals
      "deals.title": "Offerte Last-Minute",
      "deals.noDeals": "Nessuna offerta disponibile",
      "deals.available": "{count} disponibili",
      "deals.bookNow": "Prenota Ora",
      "deals.perNight": "a notte",
      "deals.nights": "{count} notti",
      
      // Requests
      "requests.title": "Richieste Viaggiatori",
      "requests.noRequests": "Nessuna richiesta disponibile",
      "requests.guests": "{count} ospiti",
      "requests.notes": "Note",
      "requests.acceptRequest": "Accetta Richiesta",
      "requests.registerToAccept": "Registrati per Accettare",
      "requests.registerFirst": "Registra prima la tua proprietà",
      "requests.viewChat": "Vedi Chat",
      
      // Status
      "status.available": "Disponibile",
      "status.open": "Aperto",
      "status.inProgress": "In Corso",
      "status.completed": "Completato",
      "status.soldOut": "Esaurito",
      
      // Labels
      "label.tonight": "Stasera",
      "label.lastMinute": "Last Minute",
      "label.weekend": "Weekend",
      
      // Calendar
      "calendar.title": "Seleziona Date (Prossimi 14 Giorni)",
      "calendar.clear": "Cancella",
      "calendar.desktopInstructions": "Desktop: Clicca e trascina per selezionare un intervallo",
      "calendar.mobileInstructions": "Mobile: Tocca per singolo, tieni premuto e trascina per intervallo",
      "calendar.selected": "Selezionati",
      "calendar.day": "giorno",
      "calendar.days": "giorni",
      
      // Messages
      "message.loggedOut": "Disconnesso"
    }
  }
};

i18n
  .use(LanguageDetector) // Rileva automaticamente la lingua del browser
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React già fa l'escape
    },
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage']
    }
  });

export default i18n;
